import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7t2qf2f5h6: FaireBrandEntity = {
  token: "b_7t2qf2f5h6",
  type: "brand",
  name: "IVE",
  avatarUrl:
    "https://cdn.faire.com/fastly/d16fbcad698bd3aaecc2ddce1441117359ed4bbf7e563a14422bf64e34780394.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/1712b347b17f2935bf1994145f6ac40df1190d0ec9b533b4517ce5d244a1851c.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d16fbcad698bd3aaecc2ddce1441117359ed4bbf7e563a14422bf64e34780394.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1712b347b17f2935bf1994145f6ac40df1190d0ec9b533b4517ce5d244a1851c.jpeg",
  location: "Los Angeles, CA, USA",
  minimumOrderDollars: 100,
  rating: 4.6,
  reviewCount: 129,
  isInsider: true,
  description:
    "Who We Are\n\nWe are a leading wholesale intermediary proudly operating out of the vibrant Los Angeles (LA) area of California, U.S.A. Rooted in the dynamic LA fashion scene, we serve as the vital link between manufacturers and retailers, ensuring the hottest styles reach the market quickly and efficiently.\n\nOur mission is simple: to provide our clients—the retailers—with the apparel that sells. We specialize in meticulously selecting and curating the most on-trend styles available. We don't just follow trends; we identify the styles that are about to define the season.\n\nWhy Partner With Us?\n\nProven Sell-Through: Our rigorous selection process ensures high performance. The apparel we distribute is consistently in high demand by retailers and frequently sells out in stores.\n\nLA Trend Authority: Operating directly within the LA fashion hub gives us an unparalleled advantage in scouting cutting-edge, trend-driven inventory that captures customer attention.\n\nReliable Partnership: As a committed intermediary, we focus on smooth logistics, dependable supply, and providing the styles that keep your inventory fresh and your profits high.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:55.765Z",
    importedBy: "entity-db-cli",
  },
};
